<script>
export default {
  props: {
    header: {
      type: Array,
      default: () => [],
    },
    datatable: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: Object,
      default: () => {},
    },
    actionbutton: {
      type: Array,
      default: () => [],
    },
    actionlink: {
      type: Array,
      default: () => [],
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: true,
      isnextActive: true,
      currentPage: 1,
      totalPage: 1,
    }
  },
  computed: {
    computedTableHeader() {
      return this.header?.map((item) => ({
        ...item,
        text: this.$t(item.text),
        align: 'center',
        class: item.class ? `${item.class} table-header` : 'table-header',
      }))
    },
    computedDatatable() {
      return this.datatable?.map((item, index) => ({
        ...item,
        index: (this.currentPage - 1) * 10 + index + 1,
      }))
    },
    computedActionbutton() {
      return this.actionbutton?.map((item) => ({
        value: this.$t(item.value),
        color: item.color,
      }))
    },
    computedActionlink() {
      return this.actionlink?.map((item) => ({
        value: this.$t(item.value),
      }))
    },
    computedPagePagination() {
      return Object.entries(this.pagination)?.forEach(([key, value]) => {
        if (key === 'page') {
          this.currentPage = value || 1
          if (value === 1 || this.currentPage === 1) {
            this.isActive = true
          } else {
            this.isActive = false
          }
        }
        if (key === 'totalPage') {
          this.totalPage = value || 1
          if (value === 1 || this.currentPage === this.totalPage) {
            this.isnextActive = true
          } else this.isnextActive = false
        }
      })
    },
  },
  watch: {
    computedPagePagination() {},
  },
  methods: {
    handleAction(item, action, value, currentPage) {
      return this.$emit('action', item, action, value, currentPage)
    },
    styleRow(item) {
      return item.index % 2 === 0 ? 'colorRowEven' : 'colorRowOdd'
    },
    prevPage() {
      this.currentPage = this.currentPage - 1
      return this.$emit('changepage', this.currentPage)
    },
    nextPage() {
      this.currentPage = this.currentPage + 1
      return this.$emit('changepage', this.currentPage)
    },
  },
}
</script>

<template>
  <div id="table_custom">
    <div class="d-flex justify-end align-center pb-2">
      <v-icon
        size="30"
        :class="{ action: isActive }"
        :disabled="isActive"
        @click="prevPage"
      >
        mdi-chevron-double-left
      </v-icon>
      <slot>{{ currentPage }} / {{ totalPage }}</slot>
      <v-icon
        size="30"
        :class="{ action: isnextActive }"
        :disabled="isnextActive"
        @click="nextPage"
      >
        mdi-chevron-double-right
      </v-icon>
    </div>
    <v-data-table
      v-bind="$attrs"
      :headers="computedTableHeader"
      :items="computedDatatable"
      :disable-sort="true"
      :items-per-page="10"
      :hide-default-footer="true"
      :item-class="styleRow"
      class="myTable"
    >
      <template v-slot:[`item.action`]="{ item }">
        <v-btn
          v-for="(action, i) in computedActionbutton"
          :key="`group-${i}`"
          :color="action.color"
          :disabled="item.disable"
          class="white--text"
          @click="handleAction(item, 'button', action.value, currentPage)"
        >
          {{ action.value }}
        </v-btn>
      </template>
      <template v-slot:[`item.link`]="{ item }">
        <a
          v-for="(action, i) in computedActionlink"
          :key="`group-${i}`"
          @click="handleAction(item, 'link', action.value, currentPage)"
        >
          {{ action.value }}
        </a>
      </template>
    </v-data-table>
  </div>
</template>

<style lang="scss">
@import '@design';

#table_custom {
  width: 100%;
  .myTable table tr td {
    overflow: hidden !important;
    text-align: left !important;
    text-overflow: ellipsis !important;
    border-right: 1px solid white;
    border-left: 1px solid white;
    &:first-child {
      text-align: center !important;
    }
    &:last-child {
      text-align: center !important;
    }
  }
  .myTable table tr:hover {
    background-color: #d2e6fa;
    transition: 0.4s;
  }
  .table-header {
    color: white;
    background-color: #307fc0;
    border: 1px solid white;
  }
  .colorRowOdd {
    background-color: #cfd5eb;
  }
  .colorRowEven {
    background-color: #e9ecf6;
  }
  .action {
    color: rgb(228, 225, 225) !important;
  }
  .v-btn--disabled {
    background-color: rgb(199, 199, 199) !important;
  }
}
</style>
